import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { mvnos } from '../../data/mvnos';

export default function MVNOCompare() {
  const [selected, setSelected] = useState(null);

  return (
    <div className="py-24 px-4 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Compare MVNO Plans</h2>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">
            After we finance your buyout, you're free to pick any of these affordable carriers. Click a provider to see their plans.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mvnos.map((mvno, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.05 }}
              onClick={() => setSelected(selected === idx ? null : idx)}
              className={`bg-white rounded-2xl border-2 cursor-pointer transition-all duration-200 overflow-hidden
                ${selected === idx ? 'border-blue-600 shadow-lg' : 'border-slate-100 hover:border-slate-300 hover:shadow-md'}`}
            >
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <span className="text-xs font-bold px-2 py-1 rounded-full text-white mb-2 inline-block"
                      style={{ backgroundColor: mvno.color }}>
                      {mvno.badge}
                    </span>
                    <h3 className="text-xl font-bold text-slate-900">{mvno.name}</h3>
                    <p className="text-sm text-slate-500">{mvno.tagline}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-xs text-slate-400">Network</div>
                    <div className="text-xs font-semibold text-slate-600">{mvno.network}</div>
                  </div>
                </div>
                <div className="flex items-end gap-1">
                  <span className="text-3xl font-extrabold text-slate-900">${Math.min(...mvno.plans.map(p => p.price))}</span>
                  <span className="text-slate-500 mb-1">/mo starting</span>
                </div>
              </div>

              {selected === idx && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  className="border-t border-slate-100 bg-slate-50 px-6 py-4"
                >
                  <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">Available Plans</p>
                  <div className="space-y-2">
                    {mvno.plans.map((plan, i) => (
                      <div key={i} className="flex justify-between items-center bg-white rounded-lg px-4 py-2 border border-slate-100">
                        <span className="text-sm font-medium text-slate-700">{plan.data} Data</span>
                        <span className="text-sm font-bold text-slate-900">${plan.price}/mo</span>
                      </div>
                    ))}
                  </div>
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}